<template>
    <div class="">
    <div class="logo-holder">
        <img alt="DaySmart Vet" src="../assets/logo.png" :class="{'rotate' : isLoading }"></div>

    <!-- LOGIN -->
    <div v-if="isLogin" class="content-holder">
        <h1>Login</h1><br>
        <form @submit.prevent="submitLogin">
        <div v-if="errorMessage" class="alert alert-danger mb-4" role="alert">
            {{ errorMessage }}
        </div>
        <div class="mb-4">
            <label for="exampleFormControlInput1" class="form-label">Email address</label>
            <input v-model="email" type="email" class="form-control" id="login-email" placeholder="name@domain.com" autocomplete="username">
        </div>
        <div class="mb-4">
            <label for="exampleFormControlInput1" class="form-label">Password</label>
            <div class="position-relative">
                <input v-model="password" :type="passwordFieldType" class="form-control" id="login-password" autocomplete="current-password">
                <font-awesome-icon icon="eye" class="show-password" v-if="hidePassword" @click="hidePassword = false"/>
                <font-awesome-icon icon="eye-slash" class="show-password" v-if="!hidePassword" @click="hidePassword = true"/>    
            </div>
            
        </div>

        <div class="row">
            <div class="col text-center">
                <small class="cursor-pointer" @click="changeContent(false)">Forgot your password ?</small>
            </div>
        </div>

        <div class="mb-4 mt-4">
            <button type="submit" class="btn btn-primary w-100 rounded-pill" :disabled="isLoading">Login 
                <small class="ml-2"><font-awesome-icon icon="chevron-right" /></small>
            </button>
        </div>
        </form>
        <div class="text-center">
            <span class="cursor-pointer">
                <a href="https://www.daysmartvet.com/demo">Not a customer? Book a demo here
                <font-awesome-icon icon="circle-chevron-right" class="text-primary ml-2"/></a> 
            </span>
        </div>
    </div>

    <!-- RECOVER PASSWORD -->
    <div v-else class="content-holder">
        <h1>Recover Password</h1><br>
        <div v-if="resetMessage" class="alert mb-4" 
            :class="messageSuccess ? 'alert-success' : 'alert-danger'" 
            role="alert">
            {{ resetMessage }}
        </div>
        <div class="mb-1">
            Enter your login email, and we'll send you instructions for resetting your password.
        </div>
        <form @submit.prevent="resetPassword">
        <div class="mb-4">
            <input v-model="email" type="email" class="form-control" id="login-email" placeholder="name@domain.com">
        </div>

        <div class="mb-4 mt-4">
            <button type="submit" class="btn btn-primary w-100 rounded-pill" :disabled="isLoading" >
                Recover Password 
                <small class="ml-2"><font-awesome-icon icon="chevron-right" /></small>
            </button>
        </div>
        </form>
        <div class="text-center" @click="changeContent(true)">
            <span class="cursor-pointer">
                <font-awesome-icon icon="chevron-left" class="text-primary mr-2"/>
                <a href="#">Nevermind, I remembered</a>
            </span>
        </div>
    </div>
    </div>
    
</template>
<script >
import { computed, ref } from "vue";
// import axios from 'axios';

export default {
mounted(){
    window.location.href = window.location.origin + "/apps/index.php/october/login";
    localStorage.clear();
},
setup(){
    const email = ref("");
    const hidePassword = ref(true);
    const password = ref("");
    const isLoading = ref(false);
    const isLogin = ref(true);
    const errorMessage = ref(null);
    const resetMessage = ref(null);
    const messageSuccess = ref(true);
    
    const SERVICE_URL = window.location.origin;

    const passwordFieldType = computed(() => hidePassword.value ? "password" : "text");

    const submitLogin = () => {
        errorMessage.value =  null;
        if(email.value && password.value){
            isLoading.value = true;
            

            let formData = new FormData();
            formData.append("fm_login_email", email.value);
            formData.append("fm_login_password", password.value);

            //disable axios

            // axios.post(SERVICE_URL + '/apps/index.php/welcome/validateLogin', formData, 
            //     { headers: {
            //         'X-Requested-With': 'XMLHttpRequest',
            //         }
            //     })
            // .then((res) => {
            //     let response = res.data;
            //     if(response.success){
            //         window.location.href = response.url ;
            //         localStorage.setItem("Vetter-Token", response.token);

            //         setTimeout(()=>{
            //             isLoading.value = false;
            //         }, 500);
            //     }else{
            //         isLoading.value = false;
            //         errorMessage.value = response.message;
            //     }
            // })
            // .catch((error) => {
            //     console.error(error);
            // })
        }else{
            errorMessage.value = 'Please fill in email address and password'
        }

        return false;
    }

    const changeContent = (toLogin) => {
        isLoading.value = false;
        isLogin.value = toLogin;
        password.value = "";
        resetMessage.value = null;
        errorMessage.value = null;
    }

    const resetPassword = () => {
        if(email.value){
            isLoading.value = true;
            let formData = new FormData();
            formData.append("fm_reset_password_email", email.value);
            
            return fetch(SERVICE_URL + '/apps/index.php/welcome/resetPassword', {
                method: 'post',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: formData
            })
            .then(res=>res.json()).then((response) => {
                messageSuccess.value = response.success;
                resetMessage.value = response.message;
            })
            .finally(()=>{
                isLoading.value = false;
            })

        }else{
            resetMessage.value = 'Please fill in email address';
            messageSuccess.value = false;

        }
    }

    return {
          email,
          hidePassword,
          passwordFieldType,
          password,
          isLoading,
          isLogin,
          errorMessage,
          resetMessage,
          messageSuccess,

          submitLogin,
          changeContent,
          resetPassword
        };
    }
}
</script>

<style type="text/css">
.content-holder{
    padding: 3em;
    text-align: left;
}

.logo-holder{
    text-align: left;
}

.logo-holder img{
    height: 30px;
}

.content-holder .text-primary {
    color: #678F35 !important;
}

.badge-right{
    background-color: #678F35;
    margin-left: 1em;
    color: #FFFFFF ;
    font-size: 10px;
}

.show-password{
    color: #d9dbe7;
    position: absolute;
    top: 10px;
    right: 10px;
}

.show-password:hover{
    color: inherit;
    
}

.rotate{
    -webkit-animation: rotation 2s infinite linear;
}

@-webkit-keyframes rotation {
    from {
            -webkit-transform: rotate(0deg);
    }
    to {
            -webkit-transform: rotate(359deg);
    }
}
</style>